module.exports = __webpack_public_path__ + "img/paint.c51eb0ed.svg";